module.exports = __webpack_public_path__ + "img/4spades.30ae24fa.jpg";